import Backdrop from '@material-ui/core/Backdrop';
import { withStyles } from "@material-ui/core/styles";

/**
 * Backdrop customization to always appear on top.
 */
const BackdropStyled = withStyles({
  root: {
    zIndex: 100
  }
})(Backdrop);

export default BackdropStyled


// WEBPACK FOOTER //
// ./src/components/common/BackdropStyled.js